'use client'
import React from "react";

import { ChakraProvider} from '@chakra-ui/react'
import { system } from "../../../chakraUiConfig/theme.config";
import { ColorModeProvider } from './color-mode'

export function Provider(props) {
  return (
    <ChakraProvider value={system}  >
      <ColorModeProvider forcedTheme={"light"} {...props} />
    </ChakraProvider>
  )
}
